import { useState, useEffect } from 'react';
import axios from 'axios';

import { parseURL } from 'helpers/video_url_parser';
import videoPlayIcon from '../../../assets/images/landers/trade_hub/video-play.png';
import videoInfoIcon from '../../../assets/images/landers/trade_hub/info.svg';

const VideoListItem = ({ item }) => {
  const [thumbSRC, setThumbSRC] = useState('');
  const [showInfo, setShowInfo] = useState(false);

  const { Thumbnail, Title, Link, Description } = item;

  const getThumb = video => {
    const videoDetails = parseURL(video);
    const videoType = videoDetails.type;
    const videoID = videoDetails.id;

    if (videoType === 'youtube') {
      setThumbSRC(`https://img.youtube.com/vi/${videoID}/maxresdefault.jpg`);
    } else if (videoType === 'vimeo') {
      axios
        .get(`https://vimeo.com/api/v2/video/${videoID}.json`)
        .then(({ data }) => {
          setThumbSRC(data[0].thumbnail_large);
        })
        .catch(error => {
          console.error(error);
        });
    }
  };

  useEffect(() => {
    if (Link !== null) {
      getThumb(Link);
    }
  }, []);

  const showVideoInfo = () => {
    setShowInfo(!showInfo);
  };

  return (
    <div>
      <div className="yt__image-wrapper">
        <a
          href={Link}
          className="yt-list__item-link"
          target="_blank"
          rel="nofollow noopener noreferrer">
          <img src={Thumbnail || thumbSRC} alt={Title} className="thumb" />
          <img className="yt__play-icon" src={videoPlayIcon} alt="play video" />
        </a>
        {showInfo && (
          <div className="yt__image-wrapper__info">
            <p className="yt__image-wrapper__info-text">{Description}</p>
          </div>
        )}
      </div>
      <p className="yt-list__item-title">
        <a
          href={Link}
          className="yt-list__item-link"
          target="_blank"
          rel="nofollow noopener noreferrer">
          {Title}
        </a>
        {Description && (
          <img
            src={videoInfoIcon}
            alt="information"
            onClick={() => showVideoInfo()}
          />
        )}
      </p>
    </div>
  );
};

export default VideoListItem;
